import { Link } from "react-router-dom";
import { SITE_INFO } from "@/mocks/data";

export default function Hero() {
  return (
    <section className="relative w-full overflow-hidden" aria-label="首页介绍">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=colorful%20manga%20comic%20illustration%20scene%20with%20many%20diverse%20anime%20characters%20celebrating%20together%2C%20warm%20red%20and%20gold%20tones%2C%20dynamic%20energetic%20composition%2C%20stylized%20graphic%20novel%20art%20style%2C%20dark%20background%20suitable%20for%20text%20overlay%2C%20high%20detail&width=1600&height=900&seq=home-hero-2026&orientation=landscape"
          alt="漫画岛漫画角色同好聚会场景插画"
          title="漫画岛同好讨论社区"
          className="h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative mx-auto flex w-full max-w-7xl flex-col items-center px-4 py-20 text-center md:px-6 md:py-28">
        <span className="flex items-center gap-2 rounded-full border border-background-50/30 bg-background-50/10 px-4 py-1.5 text-sm text-background-50 backdrop-blur">
          <i className="ri-community-line text-accent-400" aria-hidden="true"></i>
          漫画岛 · 同好讨论社区
        </span>
        <h1 className="mt-6 max-w-3xl font-heading text-3xl font-black leading-tight text-background-50 md:text-5xl">
          看完漫画来聊剧情<br className="hidden sm:block" />找同好一起追更
        </h1>
        <p className="mt-5 max-w-2xl text-sm leading-relaxed text-background-100 md:text-base">
          评论区 + 粉丝圈子，书评交流、推荐互助、安利墙随时互动。聚合热门漫画安利与深度书评，和 {SITE_INFO.members} 同好一起追更。
        </p>
        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <Link
            to="/category/reqiu"
            className="whitespace-nowrap rounded-md bg-primary-500 px-7 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            开始逛书库
          </Link>
          <Link
            to="/category/xuanyi"
            className="whitespace-nowrap rounded-md border border-background-50/40 bg-background-50/10 px-7 py-3 text-sm font-semibold text-background-50 backdrop-blur transition-colors hover:bg-background-50/20"
          >
            看热门书评
          </Link>
        </div>

        {/* 统计 */}
        <dl className="mt-12 grid w-full max-w-3xl grid-cols-3 gap-4">
          {[
            { value: SITE_INFO.members, label: "注册同好" },
            { value: SITE_INFO.articles, label: "优质书评" },
            { value: SITE_INFO.categories, label: "漫画类型" },
          ].map((s) => (
            <div key={s.label} className="rounded-lg border border-background-50/20 bg-background-50/10 px-3 py-4 backdrop-blur">
              <dd className="font-heading text-xl font-bold text-accent-400 md:text-2xl">{s.value}</dd>
              <dt className="mt-1 text-xs text-background-100 md:text-sm">{s.label}</dt>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}